import { useToggle } from '@hooks/useToggle';
import { Button } from 'reactstrap';
import { SurveyDelegationProps } from '../types';
import { DelegateWorkgroupModal } from './DelegateWorkgroupModal';
import { SurveyWorkgroup } from '@g17eco/types/workgroup';

interface Props extends Pick<SurveyDelegationProps, 'survey' | 'metricGroups'> {
  delegatedWorkgroups: SurveyWorkgroup[];
}

export const DelegateWorkgroupBtn = ({ survey, metricGroups, delegatedWorkgroups }: Props) => {
  const [isOpen, toggle] = useToggle();

  return (
    <>
      <Button color='secondary' onClick={toggle} className='ms-auto'>
        <i className='fal fa-users-medical me-2' />
        Delegate workgroup
      </Button>
      <DelegateWorkgroupModal
        key={`delegate-workgroup-modal-${isOpen}`}
        isOpen={isOpen}
        toggle={toggle}
        survey={survey}
        metricGroups={metricGroups}
        delegatedWorkgroups={delegatedWorkgroups}
      />
    </>
  );
};
